// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ptHn","content":"styles_content__XWBJj"};